/* Menu mobile (Hairmosa)
   ------------------------------------------------------------------
   Comportement repris du prototype hairmosa-menu-mobile-v3 : ouverture
   et fermeture du tiroir, accordéons dont un seul est ouvert à la fois,
   piège de focus, fermeture par glissement, blocage du défilement.

   Le tiroir est piloté par le bouton hamburger DÉJÀ présent dans
   l'en-tête du thème. Ce bouton porte aria-controls="sidebar-menu", et
   le thème lie ses propres tiroirs par délégation sur cet attribut :
   le réécrire vers l'identifiant de notre tiroir suffit donc à la fois
   à détourner le bouton et à empêcher l'ancienne barre latérale de
   s'ouvrir, sans toucher une ligne de l'en-tête. La valeur d'origine
   est mémorisée et rendue si la section est retirée.

   Tout est enfermé dans une IIFE, rien n'est posé sur window. */
(function () {
  'use strict';

  var SELECTEUR_THEME = '[aria-controls="sidebar-menu"]';
  var SEUIL_GLISSEMENT = 70;

  function boutonsDeclencheurs() {
    return Array.prototype.slice.call(
      document.querySelectorAll('[data-hmm-trigger], ' + SELECTEUR_THEME)
    );
  }

  function demarrer(racine) {
    if (!racine || racine.hmmPret) return;
    racine.hmmPret = true;

    var tiroir = racine.querySelector('[data-hmm-drawer]');
    var voile = racine.querySelector('[data-hmm-scrim]');
    var fermer = racine.querySelector('[data-hmm-close]');
    if (!tiroir) return;

    var stop = new AbortController();
    var opts = { signal: stop.signal };
    var dernierFocus = null;

    /* --- Le bouton de l'en-tête ------------------------------------- */
    function brancherBoutons() {
      boutonsDeclencheurs().forEach(function (b) {
        if (!b.hasAttribute('data-hmm-trigger')) {
          b.setAttribute('data-hmm-origine', b.getAttribute('aria-controls') || '');
          b.setAttribute('data-hmm-trigger', '');
        }
        b.setAttribute('aria-controls', tiroir.id);
        b.setAttribute('aria-expanded', estOuvert() ? 'true' : 'false');
        if (b.hmmBranche) return;
        b.hmmBranche = true;
        b.addEventListener('click', function (ev) {
          ev.preventDefault();
          basculer();
        });
      });
    }

    function rendreBoutons() {
      boutonsDeclencheurs().forEach(function (b) {
        var origine = b.getAttribute('data-hmm-origine');
        if (origine) b.setAttribute('aria-controls', origine);
        b.removeAttribute('data-hmm-origine');
        b.removeAttribute('data-hmm-trigger');
      });
    }

    /* --- Ouverture et fermeture ------------------------------------- */
    function estOuvert() {
      return racine.classList.contains('is-open');
    }

    function ouvrir() {
      if (estOuvert()) return;
      dernierFocus = document.activeElement;
      racine.classList.add('is-open');
      document.body.classList.add('hmm-lock');
      tiroir.removeAttribute('inert');
      marquerBoutons(true);
      setTimeout(function () {
        if (fermer) fermer.focus();
      }, 60);
    }

    function refermer() {
      if (!estOuvert()) return;
      racine.classList.remove('is-open');
      document.body.classList.remove('hmm-lock');
      tiroir.setAttribute('inert', '');
      marquerBoutons(false);
      if (dernierFocus && dernierFocus.focus) dernierFocus.focus();
    }

    function basculer() {
      if (estOuvert()) refermer();
      else ouvrir();
    }

    function marquerBoutons(ouvert) {
      boutonsDeclencheurs().forEach(function (b) {
        b.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
      });
    }

    if (fermer) fermer.addEventListener('click', refermer, opts);
    if (voile) voile.addEventListener('click', refermer, opts);
    document.addEventListener('keydown', function (ev) {
      if (ev.key === 'Escape' && estOuvert()) refermer();
    }, opts);

    /* --- Accordéons, un seul ouvert --------------------------------- */
    var declencheurs = racine.querySelectorAll('[data-hmm-acc]');
    Array.prototype.forEach.call(declencheurs, function (t) {
      t.addEventListener('click', function () {
        var etaitOuvert = t.getAttribute('aria-expanded') === 'true';
        Array.prototype.forEach.call(declencheurs, function (autre) {
          autre.setAttribute('aria-expanded', 'false');
        });
        t.setAttribute('aria-expanded', etaitOuvert ? 'false' : 'true');
      }, opts);
    });

    function ouvrirAccordeon(cle) {
      Array.prototype.forEach.call(declencheurs, function (t) {
        t.setAttribute('aria-expanded', t.getAttribute('data-hmm-acc') === cle ? 'true' : 'false');
      });
    }

    /* --- Piège de focus --------------------------------------------- */
    tiroir.addEventListener('keydown', function (ev) {
      if (ev.key !== 'Tab') return;
      var f = tiroir.querySelectorAll('a[href], button:not([disabled])');
      if (!f.length) return;
      var premier = f[0];
      var dernier = f[f.length - 1];
      if (ev.shiftKey && document.activeElement === premier) {
        ev.preventDefault();
        dernier.focus();
      } else if (!ev.shiftKey && document.activeElement === dernier) {
        ev.preventDefault();
        premier.focus();
      }
    }, opts);

    /* --- Fermeture par glissement vers la gauche ---------------------
       L'axe est décidé au premier mouvement : tant qu'il est vertical,
       on ne touche à rien et le corps défile normalement. */
    var x0 = null, y0 = null, dx = 0, axe = null;

    tiroir.addEventListener('touchstart', function (ev) {
      if (ev.touches.length !== 1) return;
      x0 = ev.touches[0].clientX;
      y0 = ev.touches[0].clientY;
      dx = 0;
      axe = null;
    }, { passive: true, signal: stop.signal });

    tiroir.addEventListener('touchmove', function (ev) {
      if (x0 === null) return;
      var x = ev.touches[0].clientX;
      var y = ev.touches[0].clientY;
      if (axe === null) {
        axe = Math.abs(x - x0) > Math.abs(y - y0) ? 'x' : 'y';
        if (axe === 'x') tiroir.classList.add('is-dragging');
      }
      if (axe !== 'x') return;
      dx = Math.min(0, x - x0);
      tiroir.style.transform = 'translateX(' + dx + 'px)';
    }, { passive: true, signal: stop.signal });

    tiroir.addEventListener('touchend', function () {
      if (axe === 'x') {
        tiroir.classList.remove('is-dragging');
        tiroir.style.transform = '';
        if (dx < -SEUIL_GLISSEMENT) refermer();
      }
      x0 = null; y0 = null; dx = 0; axe = null;
    }, opts);

    /* --- Éditeur de thème -------------------------------------------
       Sélectionner un bloc ouvre le tiroir, ouvre l'accordéon qui le
       contient et fait défiler jusqu'à lui. */
    document.addEventListener('shopify:block:select', function (ev) {
      if (!ev.detail) return;
      var cible = racine.querySelector('[data-hmm-block="' + ev.detail.blockId + '"]');
      if (!cible) return;
      ouvrir();
      var groupe = cible.closest('[data-hmm-groupe]');
      if (groupe) ouvrirAccordeon(groupe.getAttribute('data-hmm-groupe'));
      setTimeout(function () {
        cible.scrollIntoView({ block: 'center', behavior: 'smooth' });
      }, 220);
    }, opts);

    document.addEventListener('shopify:block:deselect', function (ev) {
      if (!ev.detail) return;
      if (racine.querySelector('[data-hmm-block="' + ev.detail.blockId + '"]')) refermer();
    }, opts);

    /* L'en-tête peut être re-rendu par l'éditeur : le hamburger est
       alors neuf et le thème s'y relie de nouveau. On le reprend. */
    document.addEventListener('shopify:section:load', brancherBoutons, opts);

    racine.hmmArreter = function () {
      refermer();
      rendreBoutons();
      stop.abort();
      racine.hmmPret = false;
    };

    brancherBoutons();
  }

  function demarrerTout() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-hmm-root]'),
      demarrer
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrerTout, { once: true });
  } else {
    demarrerTout();
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var racine = ev.target && ev.target.querySelector
      ? ev.target.querySelector('[data-hmm-root]')
      : null;
    if (racine) demarrer(racine);
  });

  document.addEventListener('shopify:section:unload', function (ev) {
    var racine = ev.target && ev.target.querySelector
      ? ev.target.querySelector('[data-hmm-root]')
      : null;
    if (racine && racine.hmmArreter) racine.hmmArreter();
  });
})();
